"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterButtonOverlay = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _hooks = require("../../hooks");
var _space = require("../../styles/variables/_space");
var _utils = require("../../utils");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _ButtonDropdown = require("../ButtonDropdown");
var _Tooltip = require("../Tooltip");
var _FilterButtonOverlayModule = _interopRequireDefault(require("./FilterButtonOverlay.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FilterButtonOverlay = exports.FilterButtonOverlay = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    anchorPosition = _ButtonDropdown.ANCHOR_POSITION_TYPE.bottomStart,
    positionStrategy = _ButtonDropdown.STRATEGY_TYPE.absolute,
    clickAwayRef,
    size = 'medium',
    children,
    isFluid,
    buttonLabel,
    buttonIsFluid,
    buttonSize,
    elevation = 'modal',
    ...restProps
  } = _ref;
  const {
    x,
    y,
    refs,
    strategy,
    context
  } = (0, _react2.useFloating)({
    open: true,
    // @ts-ignore - TS2322 - Type 'string' is not assignable to type 'Strategy | undefined'.
    strategy: positionStrategy,
    // @ts-ignore - TS2322 - Type 'string' is not assignable to type 'Placement | undefined'.
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });

  // @ts-ignore - TS2345 - Argument of type '(ReferenceType & ReferenceType) | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
  const dropdownWidth = (0, _hooks.useReferenceElementWidth)(refs.reference?.current);
  return /*#__PURE__*/React.createElement(_utils.ClickAway, {
    clickAwayRef: clickAwayRef,
    closeOnEscapeKeypress: true,
    containsNestedFloatingPortals: true
  }, _ref2 => {
    let {
      isOpen,
      onOpen,
      boundaryRef,
      triggerRef
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "FilterButtonOverlay",
      className: (0, _classify.default)({
        [_FilterButtonOverlayModule.default.isFluid]: buttonIsFluid
      }, classNames?.wrapper),
      ref: ref
    }, /*#__PURE__*/React.createElement(_Button.Button, _extends({}, restProps, {
      // @ts-ignore - TS2322 - Type '((node: ReferenceType | null) => void) & ((node: ReferenceType | null) => void)' is not assignable to type '{ current: HTMLElement | null | undefined; }'.
      ref: (0, _utils.mergeRefs)([refs.setReference, triggerRef]),
      onClick: e => {
        e.stopPropagation();
        onOpen();
      },
      isFluid: buttonIsFluid,
      size: buttonSize
    }), buttonLabel), isOpen && /*#__PURE__*/React.createElement(_react2.FloatingPortal, null, /*#__PURE__*/React.createElement(_react2.FloatingFocusManager, {
      modal: false,
      context: context
      // @ts-ignore - TS2322 - Type 'MutableRefObject<ReferenceType | null> & MutableRefObject<ReferenceType | null>' is not assignable to type 'number | MutableRefObject<HTMLElement | null> | undefined'.
      ,
      initialFocus: refs.reference
    }, /*#__PURE__*/React.createElement("div", {
      // @ts-ignore - TS2322 - Type '((node: HTMLElement | null) => void) & ((node: HTMLElement | null) => void)' is not assignable to type '{ current: HTMLElement | null | undefined; }'.
      ref: (0, _utils.mergeRefs)([refs.setFloating, boundaryRef]),
      className: _FilterButtonOverlayModule.default.overlayContainer,
      style: {
        display: 'flex',
        position: strategy,
        top: y ?? _space.spaceNone,
        left: x ?? _space.spaceNone,
        /* NOTE(Sharad): The FloatingPortal renders the menu outside the normal DOM structure,
        so its parent is effectively the <body> element. This means the menu
        would otherwise default to the body's width. To support fluid width,
        we must manually set the dropdown width here; otherwise, it uses a fixed width.
        Also, Only treat menu as non-fluid if isFluid is strictly false, since default is true in menu and undefined means fluid. */
        ...(isFluid !== false && {
          '--dropdown-width': dropdownWidth
        }),
        '--menu-elevation': (0, _Tooltip.getElevationValue)(elevation)
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: (0, _classify.default)(_FilterButtonOverlayModule.default.overlayWrapper, {
        [_FilterButtonOverlayModule.default.fluid]: isFluid,
        [_FilterButtonOverlayModule.default.small]: size === 'small',
        [_FilterButtonOverlayModule.default.medium]: size === 'medium'
      }, classNames?.overlayContainer)
    }, children)))));
  });
});